import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=5de8dba2&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8dba2",
  null
  
)

export default component.exports